var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',{attrs:{"value":_vm.selectedItems,"label":"text","placeholder":_vm.placeholder,"track-by":"value","options":_vm.options,"multiple":true,"disabled":_vm.disabled},on:{"input":_vm.input}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d728f5a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MultiSelectField.vue
// module id = SQcq
// module chunks = 0 108 121